import request from "../request";

export const getPeriodicalReportClassesById = (periodicalReportId, data) =>
  request.post(`/periodical-report/classes/${periodicalReportId}`, data).then((res) => res);



